import { memo } from 'react';

function PlusBtnAdd({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      fill="none"
      viewBox="0 0 16 15"
    >
      <path
        fill={color}
        d="M7.167 14.167a.833.833 0 001.666 0V8.333h5.834a.833.833 0 000-1.666H8.833V.833a.833.833 0 10-1.666 0v5.834H1.333a.833.833 0 100 1.666h5.834v5.834z"
      ></path>
    </svg>
  );
}

export default memo(PlusBtnAdd);
